/* eslint-disable @typescript-eslint/no-var-requires */
export const phoenixShopHotelDirectoryData = require('./phoenixShopHotelDirectoryData.graphql');
export const phoenixShopSearchPropertiesByDestination = require('./phoenixShopSearchPropertiesByDestination.graphql');
export const phoenixShopSearchPropertiesByLocationInput = require('./phoenixShopSearchPropertiesByLocationInput.graphql');
